module.exports = __webpack_public_path__ + "static/Light-Green-591b33c596fec1e8e765e7ffebaa7d3e.png";